export default __webpack_public_path__ + "static/media/a017-d.32f20df8.svg";